export const SET_SELECTED_SEATS = 'SET_SELECTED_SEATS';
export const SET_SUGGESTED_SEATS = 'SET_SUGGESTED_SEATS';
export const SET_SELECTED_CINEMA = 'SET_SELECTED_CINEMA';
export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const SET_SELECTED_TIME = 'SET_SELECTED_TIME';
export const TOGGLE_LOGIN_POPUP = 'TOGGLE_LOGIN_POPUP';
export const SHOW_INVITATION_FORM = 'SHOW_INVITATION_FORM';
export const SET_INVITATION = 'SET_INVITATION';
export const SET_QR_CODE = 'SET_QR_CODE';
export const RESET_CHECKOUT = 'RESET_CHECKOUT';
export const SET_SELECTED_FOOD = 'SET_SELECTED_FOOD';
export const CLEAR_SELECTED_FOOD = 'CLEAR_SELECTED_FOOD';
export const SET_PENDING_RESERVATION = 'SET_PENDING_RESERVATION';
export const SET_FOOD_DELIVERY_TIME = 'SET_FOOD_DELIVERY_TIME';
export const SET_FOOD_DELIVERY_METHOD = 'SET_FOOD_DELIVERY_METHOD';
